export default "<div class=\"sc-button\" [ngClass]=\"getStyles()\">\n  <ng-content></ng-content>\n</div>\n"